export default {
  parking_space: (state) => {
    return state.parking_space;
  }
}
